var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "well",
    staticStyle: { width: "100%" },
    attrs: { scrolling: "yes" },
    domProps: { innerHTML: _vm._s(_vm.preview) }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }